import { useOutletContext, useParams } from "react-router";

import { WorkbenchContext } from "../types";

import RfpDocumentsCard from "./rfpDocumentsCard";

function WorkbenchDeliverables(): React.JSX.Element {
  const { id: rfpId } = useParams();
  const { refetchRpfDetails } = useOutletContext<WorkbenchContext>();

  return (
    <RfpDocumentsCard
      rfpId={rfpId}
      displayInCard={false}
      onMarketingPresentationUploaded={refetchRpfDetails}
    />
  );
}

export default WorkbenchDeliverables;
